/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

const createInvitationsPageStyles = makeStyles(() => ({
  root: {
    display: 'flex',
  },
  navigation: {
    flex: '0 0 auto',
    maxWidth: '200px',
  },
  content: {
    flex: '1 1 auto',
    paddingLeft: '56px',
  },
}));

export { createInvitationsPageStyles };
